import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { forwardRef } from "react";
import { genericHashLink, HashLink } from "react-router-hash-link";
import GatsbyLink from "gatsby-link";
import atomize from "@quarkly/atomize";
var relative = new RegExp("^(?:[a-z]+:)?//", "i");
var mail = new RegExp("^mailto:", "i");

var GatsbyHashLink = function GatsbyHashLink(props) {
  return genericHashLink(props, GatsbyLink);
};

var getEnvType = function getEnvType() {
  var globalThis = null;

  if (typeof window !== "undefined") {
    globalThis = window;
  } else if (typeof global !== "undefined") {
    globalThis = global;
  } else {
    return null;
  }

  if (!globalThis.QAPI) {
    return null;
  }

  return globalThis.QAPI.projectType;
};

var A = forwardRef(function (props, ref) {
  var _props$href = props.href,
      href = _props$href === void 0 ? "" : _props$href,
      target = props.target,
      rest = _objectWithoutProperties(props, ["href", "target"]);

  var isAbsolute = relative.test(href);
  var isMail = mail.test(href);
  var isNewTab = target === "_blank";
  var isRouter = !isAbsolute && !isMail && !isNewTab;
  var projectType = getEnvType();

  if (isRouter) {
    var Link = HashLink;

    if (projectType === "gatsby") {
      Link = GatsbyHashLink;
    }

    return React.createElement(Link, _extends({
      to: href,
      ref: ref
    }, rest));
  }

  return React.createElement("a", _extends({
    href: href,
    target: target,
    ref: ref
  }, rest));
});
export default atomize(A)({
  name: "Link",
  effects: {
    link: ":link",
    hover: ":hover",
    visited: ":visited",
    active: ":active"
  },
  normalize: true,
  mixins: true,
  description: {
    en: "Text element — text in different variants: paragraph, heading, etc.",
    ru: "Элемент text — текст в различных вариантах: параграф, заголовок, и другие"
  },
  propInfo: {
    href: {
      weight: 1,
      control: "input",
      category: "Main",
      description: {
        en: "href — destination address where the link takes to",
        ru: "href — адрес назначения, по которому направляет ссылка"
      }
    },
    target: {
      weight: 1,
      control: "select",
      variants: ["_self", "_blank", "_parent", "_top"],
      category: "Main"
    }
  }
});